<div id="layoutSidenav">
    <div id="layoutSidenav_content">
        <main>

            <div class="container-fluid px-5 pt-5 mt-4">
                <!-- Total Leads Section -->
                <!-- Coupon Banner -->


                    <h2 class="mb-4">Sub Franchises({{allStaffRecords.length}})</h2>
                    <div style="float: right; position: relative; top: -8px;">
                        <button type="button" class="btn btn-primary" (click)="addStaff()">Add Sub Franchise</button>
                    </div>
               

                <!-- Data Table -->
                <div class="table-responsive">
                    <table class="table table-hover">
                        <thead class="table-primary">
                            <tr>
                       
                                <th>S.No</th>
                                <th>Name</th>
                                <th>Email</th>
                                <th>Mobile</th>
                                <th>City</th>
                                <th>District</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let records of allStaffRecords; let i = index;">
                                <td>{{i+1}}</td>
                                <td>{{records.personalDetails.firstName}}</td>
                                <td>{{records.personalDetails.email}}</td>
                                <td>{{records.personalDetails.mobile}}</td>
                                <td>{{records.personalDetails.city}}</td>
                                <td>{{records.personalDetails.district}}</td>
                                <td><button class="btn btn-sm btn-outline-danger">
                                    <i class="fa-solid fa-trash"></i>
                                  </button></td>
                            </tr>
                           
                        </tbody>
                    </table>
                </div>
            </div>
        </main>
    
    </div>
</div>